import React from 'react';
import { Button, ButtonProps } from '@mui/material';

const ScorecardButtonBase: React.FC<ButtonProps> = ({ children, ...props }) => {
    return (
        <Button {...props} size="small" color="inherit">
            {children}
        </Button>
    );
};

export default ScorecardButtonBase;
